import React from "react"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"

const TableHeader = ({ t }) => {
  const propsTypo = {
    htmlTag: "th",
    size: "small",
    color: "outer_space",
    weight: "regular"
  }

  return (
    <thead>
      <tr>
        <Typograph {...propsTypo}>{t("MSG_0249")}</Typograph>
        <Typograph {...propsTypo}>{t("MSG_0239")}</Typograph>
        <Typograph {...propsTypo}>{t("MSG_0052")}</Typograph>
        <th></th>
      </tr>
    </thead>
  )
}

TableHeader.propTypes = {
  t: PropTypes.func
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/Requests/Header.js